import { render } from "./StockEdit.vue?vue&type=template&id=6838ba53&scoped=true"
import script from "./StockEdit.vue?vue&type=script&lang=js"
export * from "./StockEdit.vue?vue&type=script&lang=js"

import "./StockEdit.vue?vue&type=style&index=0&id=6838ba53&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6838ba53"]])

export default __exports__